import * as DTOS from "../FeralScan.dtos";

export interface IAdminActions {
    type: string;
}

export interface IGetPlotMetaInfoRequest extends IAdminActions {
}

export interface IGetPlotMetaInfoSuccess extends IAdminActions {
    apcCodes: string[];
    waterBodys: string[];
    users: DTOS.User[];
    userRoles: DTOS.UserRole[];
}

export interface ISearchPlotsRequest extends IAdminActions {
    searchText?: string;
    includeObsolete?: boolean;
}

export interface ISearchPlotsSuccess extends IAdminActions {
    plots: DTOS.Plot[];
}

export interface ISearchFilesRequest extends IAdminActions {
    searchText?: string;
    includeObsolete?: boolean;
}

export interface ISearchFilesSuccess extends IAdminActions {
    files: DTOS.FileRecord[];
}

export interface ISearchUsersRequest extends IAdminActions {
    searchText?: string;
    includeObsolete?: boolean;
}

export interface ISearchUsersSuccess extends IAdminActions {
    users: DTOS.User[];
}

export interface ISearchUserRolesRequest extends IAdminActions {
    userId?: number;
    plotId?: number;
}

export interface ISearchUserRolesSuccess extends IAdminActions {
    userRoles: DTOS.UserRole[];
}

export interface IEditUserRequest extends IAdminActions {
    user: DTOS.User;
}

export interface IEditUserSuccess extends IAdminActions {
    user: DTOS.User;
}

export interface IEditUserFailure extends IAdminActions {
}

export interface IGetSingleUserRequest extends IAdminActions {
    userId: number;
}

export interface IGetSingleUserSuccess extends IAdminActions {
    user: DTOS.User;
}

export interface IBatchAdminImportRequest extends IAdminActions {
    files: File[];
    plotId?: number;
    userId?: number;
}

export interface IBatchAdminImportSuccess extends IAdminActions {
    response: any;
}

export interface IBatchAdminImportFail extends IAdminActions {
    response: any;
}

export interface IBatchAdminImportClearError extends IAdminActions {
}

export type AdminAction = {
    type: string,

    //inviteUserToUserGroup
    email?: string,

    //editUserGroups editUserGroupsSuccess
    group?: DTOS.UserGroup,

    //approveUserForUserGroup approveUserForUserGroupSuccess deleteUserFromUserGroup deleteUserFromUserGroupSuccess
    //inviteUserToUserGroup inviteUserToUserGroupSuccess setAdminUserUserGroup setAdminUserUserGroupSuccess
    groupId?: number,

    //searchUserGroupsSuccess
    groups?: DTOS.UserGroup[],

    //inviteUserToUserGroup
    name?: string,

    //searchUsers
    pending?: boolean,

    //searchPlotsSuccess
    plots?: DTOS.Plot[],

    //searchPlots searchUserGroups searchUsers
    text?: string,

    //editUser editUserSuccess inviteUserToUserGroupSuccess
    user?: DTOS.User,

    //approveUserForUserGroupSuccess setAdminUserUserGroupSuccess
    userGroupMember?: DTOS.UserGroupMember,

    //approveUserForUserGroup deleteUserFromUserGroup deleteUserFromUserGroupSuccess setAdminUserUserGroup
    userId?: number,

    //searchUsersSuccess
    users?: DTOS.User[]
}

export const
    ADMIN_SEARCH_PLOTS_REQUEST = "ADMIN_SEARCH_PLOTS_REQUEST",
    ADMIN_SEARCH_PLOTS_SUCCESS = "ADMIN_SEARCH_PLOTS_SUCCESS",

    ADMIN_GET_PLOT_METAINFO_REQUEST = "ADMIN_GET_PLOT_METAINFO_REQUEST",
    ADMIN_GET_PLOT_METAINFO_SUCCESS = "ADMIN_GET_PLOT_METAINFO_SUCCESS",

    ADMIN_SEARCH_FILES_REQUEST = "ADMIN_SEARCH_FILES_REQUEST",
    ADMIN_SEARCH_FILES_SUCCESS = "ADMIN_SEARCH_FILES_SUCCESS",

    ADMIN_SEARCH_USERS_REQUEST = "ADMIN_SEARCH_USERS_REQUEST",
    ADMIN_SEARCH_USERS_SUCCESS = "ADMIN_SEARCH_USERS_SUCCESS",

    ADMIN_SEARCH_USER_ROLES_REQUEST = "ADMIN_SEARCH_USER_ROLES_REQUEST",
    ADMIN_SEARCH_USER_ROLES_SUCCESS = "ADMIN_SEARCH_USER_ROLES_SUCCESS",

    ADMIN_GET_SINGLE_USER_REQUEST = "ADMIN_GET_SINGLE_USER_REQUEST",
    ADMIN_GET_SINGLE_USER_SUCCESS = "ADMIN_GET_SINGLE_USER_SUCCESS",

    ADMIN_SEARCH_USER_GRP_REQUEST = "ADMIN_SEARCH_USER_GRP_REQUEST",
    ADMIN_SEARCH_USER_GRP_SUCCESS = "ADMIN_SEARCH_USER_GRP_SUCCESS",

    ADMIN_EDIT_USER_GRP_REQUEST = "ADMIN_EDIT_USER_GRP_REQUEST",
    ADMIN_EDIT_USER_GRP_SUCCESS = "ADMIN_EDIT_USER_GRP_SUCCESS",

    ADMIN_EDIT_USER_REQUEST = "ADMIN_EDIT_USER_REQUEST",
    ADMIN_EDIT_USER_SUCCESS = "ADMIN_EDIT_USER_SUCCESS",
    ADMIN_EDIT_USER_FAILURE = "ADMIN_EDIT_USER_FAILURE",

    ADMIN_ADD_USER_TO_GRP_REQUEST = "ADMIN_ADD_USER_TO_GRP_REQUEST",
    ADMIN_ADD_USER_TO_GRP_SUCCESS = "ADMIN_ADD_USER_TO_GRP_SUCCESS",

    ADMIN_DEL_USER_FROM_GRP_REQUEST = "ADMIN_DEL_USER_FROM_GRP_REQUEST",
    ADMIN_DEL_USER_FROM_GRP_SUCCESS = "ADMIN_DEL_USER_FROM_GRP_SUCCESS",

    ADMIN_APRROVE_USER_4_GRP_REQUEST = "ADMIN_APRROVE_USER_4_GRP_REQUEST",
    ADMIN_APRROVE_USER_4_GRP_SUCCESS = "ADMIN_APRROVE_USER_4_GRP_SUCCESS",

    ADMIN_USER_GRP_REQUEST = "ADMIN_USER_GRP_REQUEST",
    ADMIN_USER_GRP_SUCCESS = "ADMIN_USER_GRP_SUCCESS",

    ADMIN_BATCH_IMPORT_REQUEST = "ADMIN_BATCH_IMPORT_REQUEST",
    ADMIN_BATCH_IMPORT_SUCCESS = "ADMIN_BATCH_IMPORT_SUCCESS",
    ADMIN_BATCH_IMPORT_FAIL = "ADMIN_BATCH_IMPORT_FAIL",
    ADMIN_BATCH_IMPORT_CLEAR_ERROR = "ADMIN_BATCH_IMPORT_CLEAR_ERROR";

export function searchPlotsRequest(searchText: string, includeObsolete: boolean): ISearchPlotsRequest {
    return {
        type: ADMIN_SEARCH_PLOTS_REQUEST,
        searchText,
        includeObsolete
    };
}

export function searchPlotsSuccess(response: DTOS.AdminPlotsResponse): ISearchPlotsSuccess {
    return {
        type: ADMIN_SEARCH_PLOTS_SUCCESS,
        plots: response.plots
    };
}
    
export function getPlotMetaInfoRequest(): IGetPlotMetaInfoRequest {
    return {
        type: ADMIN_GET_PLOT_METAINFO_REQUEST
    };
}

export function getPlotMetaInfoSuccess(response: DTOS.AdminGetPlotMetaInfoResponse): IGetPlotMetaInfoSuccess {
    return {
        type: ADMIN_GET_PLOT_METAINFO_SUCCESS,
        apcCodes: response.apcCodes,
        waterBodys: response.waterBodys,
        users: response.users,
        userRoles: response.userRoles
    };
}

export function searchFilesRequest(searchText: string): ISearchFilesRequest {
    return {
        type: ADMIN_SEARCH_FILES_REQUEST,
        searchText,
    };
}

export function searchFilesSuccess(response: DTOS.AdminFilesResponse): ISearchFilesSuccess {
    return {
        type: ADMIN_SEARCH_FILES_SUCCESS,
        files: response.files
    };
}

export function batchImportRequest(files: File[], plotId?: number, userId?: number): IBatchAdminImportRequest {
    return {
        type: ADMIN_BATCH_IMPORT_REQUEST,
        files,
        plotId,
        userId
    };
}

export function batchImportSuccess(response: DTOS.AdminBatchImportResponse): IBatchAdminImportSuccess {
    return {
        type: ADMIN_BATCH_IMPORT_SUCCESS,
        response
    };
}

export function batchImportFail(response: DTOS.AdminBatchImportResponse): IBatchAdminImportFail {
    return {
        type: ADMIN_BATCH_IMPORT_FAIL,
        response
    };
}

export function batchImportClearError(): IBatchAdminImportClearError {
    return {
        type: ADMIN_BATCH_IMPORT_CLEAR_ERROR
    };
}

export function getSingleUserRequest(userId: number): IGetSingleUserRequest {
    return {
        type: ADMIN_GET_SINGLE_USER_REQUEST,
        userId
    };
}

export function getSingleUserSuccess(response: DTOS.AdminUsersResponse): IGetSingleUserSuccess {
    return {
        type: ADMIN_GET_SINGLE_USER_SUCCESS,
        user: response.users && response.users.length > 0 ? response.users[0] : undefined
    };
}

export function searchUsersRequest(searchText: string, includeObsolete: boolean): ISearchUsersRequest {
    return {
        type: ADMIN_SEARCH_USERS_REQUEST,
        searchText,
        includeObsolete
    };
}

export function searchUsersSuccess(response: DTOS.AdminUsersResponse): ISearchUsersSuccess {
    return {
        type: ADMIN_SEARCH_USERS_SUCCESS,
        users: response.users
    };
}

export function searchUserRolesRequest(userId: number, plotId: number): ISearchUserRolesRequest {
    return {
        type: ADMIN_SEARCH_USER_ROLES_REQUEST,
        userId,
        plotId
    };
}

export function searchUserRolesSuccess(response: DTOS.AdminUserRolesResponse): ISearchUserRolesSuccess {
    return {
        type: ADMIN_SEARCH_USER_ROLES_SUCCESS,
        userRoles: response.userRoles
    };
}

export function searchUserGroups(text: string): AdminAction {
    return {
        type: ADMIN_SEARCH_USER_GRP_REQUEST,
        text
    };
}

export function searchUserGroupsSuccess(response: DTOS.AdminUserGroupsResponse): AdminAction {
    return {
        type: ADMIN_SEARCH_USER_GRP_SUCCESS,
        groups: response.groups
    };
}


export function editUserGroups(group: DTOS.UserGroup): AdminAction {
    return {
        type: ADMIN_EDIT_USER_GRP_REQUEST,
        group
    };
}

export function editUserGroupsSuccess(response: DTOS.AdminSaveUserGroupResponse): AdminAction {
    return {
        type: ADMIN_EDIT_USER_GRP_SUCCESS,
        group: response.group
    };
}

export function inviteUserToUserGroup(groupId: number, email: string, name: string): AdminAction {
    return {
        type: ADMIN_ADD_USER_TO_GRP_REQUEST,
        groupId,
        email,
        name
    };
}

export function inviteUserToUserGroupSuccess(response: DTOS.AdminAddUserToGroupResponse): AdminAction {
    return {
        type: ADMIN_ADD_USER_TO_GRP_SUCCESS,
        userGroupMember: response.user,
        groupId: response.groupId
    };
}

export function editUser(user: DTOS.User): IEditUserRequest {
    return {
        type: ADMIN_EDIT_USER_REQUEST,
        user
    };
}

export function editUserSuccess(response: DTOS.AdminSaveUserResponse): IEditUserSuccess {
    return {
        type: ADMIN_EDIT_USER_SUCCESS,
        user: response.user
    };
}

export function editUserFailure(): IEditUserFailure {
    return {
        type: ADMIN_EDIT_USER_FAILURE
    };
}

export function deleteUserFromUserGroup(groupId: number, userId: number): AdminAction {
    return {
        type: ADMIN_DEL_USER_FROM_GRP_REQUEST,
        groupId,
        userId
    };
}

export function deleteUserFromUserGroupSuccess(response: DTOS.AdminDeleteUserFromGroupResponse): AdminAction {
    return {
        type: ADMIN_DEL_USER_FROM_GRP_SUCCESS,
        userId: response.userId,
        groupId: response.groupId
    };
}


export function approveUserForUserGroup(groupId: number, userId: number): AdminAction {
    return {
        type: ADMIN_APRROVE_USER_4_GRP_REQUEST,
        groupId,
        userId
    };
}

export function approveUserForUserGroupSuccess(response: DTOS.AdminApproveUserForGroupResponse): AdminAction {
    return {
        type: ADMIN_APRROVE_USER_4_GRP_SUCCESS,
        userGroupMember: response.user,
        groupId: response.groupId
    };
}

export function setAdminUserUserGroup(groupId: number, userId: number): AdminAction {
    return {
        type: ADMIN_USER_GRP_REQUEST,
        groupId,
        userId
    };
}

export function setAdminUserUserGroupSuccess(response: DTOS.AdminUpdateAdminUserGroupResponse): AdminAction {
    return {
        type: ADMIN_USER_GRP_SUCCESS,
        userGroupMember: response.user,
        groupId: response.groupId
    };
}